import "./DesktopRewarded.css";
import { useLang } from "../../../../i18n/LangContext";
import rewardedMonitor from "../../../../assets/desktopAdvertise/rewarded/rewarded-monitor.png";

export default function DesktopRewarded({ id = "monetize" }) {
  const { t } = useLang();
  const data = t?.advertiseRewarded;
  if (!data) return null;

  return (
    <section id={id} className="rewarded-root rewarded-desktop" aria-label="Rewarded ads">
      <div className="rewarded-wrap">
        <div className="rewarded-left">
          <p className="rewarded-eyebrow">{data.eyebrow}</p>
          <h2 className="rewarded-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
          <p className="rewarded-desc">{data.desc}</p>
        </div>

        <div className="rewarded-right">
          <img src={rewardedMonitor} alt={data.imageAlt} loading="lazy" />
        </div>
      </div>
    </section>
  );
}
